import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Radio, RadioGroup } from '@opendate-app/setlist';

const SeatMapSwapPricesModal = ({ seatingChart, onClose, onConfirm }) => {
  const [choice, setChoice] = useState('keep');

  useEffect(() => {
    if (seatingChart) { setChoice('keep'); }
  }, [seatingChart]);

  return (
    <Modal
      open={!!seatingChart}
      title="Switch seat map"
      confirmLabel="Switch seat map"
      onClose={onClose}
      onConfirm={() => onConfirm(choice === 'keep')}
    >
      <p className="mb-3">What should sections that are on both maps cost?</p>
      <RadioGroup name="seat-map-swap-prices" value={choice} onChange={setChoice}>
        <div className="mb-2"><Radio id="seat-map-swap-keep-prices" value="keep" label="Keep the prices you set" /></div>
        <div className="mb-2"><Radio id="seat-map-swap-new-prices" value="new" label="Use the new map's prices" /></div>
      </RadioGroup>
      <p className="text-muted small mb-0">Tickets already sold keep the price the fan paid.</p>
    </Modal>
  );
};

SeatMapSwapPricesModal.propTypes = {
  seatingChart: PropTypes.shape({
    id: PropTypes.number
  }),
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

SeatMapSwapPricesModal.defaultProps = {
  seatingChart: null
};

export default SeatMapSwapPricesModal;
